import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import Content from "./components/common/content/Content";
import Footer from "./components/common/footer/Footer";
import Header from "./components/common/header/Header";
import { ToastContainer } from "react-toastify";
import { useEffect,useState } from "react";
import { useLocation } from "react-router-dom";
import AdminDashboard from "./pages/admincontents/components/admindashboard/AdminDashboard";
import NotFound from "./components/common/notFound/notFound";

function App() {
 
  const location = useLocation();
  const accessToken: any = null;
  
  const [resetSlider, setResetSlider] = useState(false); // Manage slider reset state
  
  useEffect(() => {
    setResetSlider(false); // Reset slider state on location change
  }, [location]);

  const handleResetSlider = () => {
    setResetSlider(true); // Trigger slider reset
    setTimeout(() => setResetSlider(false), 100); // Reset back after a brief delay
  };

  const handleContextMenu = (e:any) => {
    e.preventDefault();
  };

    const isAdminRoute = location.pathname.startsWith("/admin");

  // Public layout routes
  const publicRoutes = [
    "/",
    "/createmeeting",
    "/trueasuretrove",
    "/customerbrandsinsights",
    "/salesconsumptionanalytics",
    "/trueasuretrove/growth",
    "/trueasuretrove/promotion",
    "/trueasuretrove/customer_experience",
    "/trueasuretrove/ready_brand_launch",
    "/trueasuretrove/trend_forecast",
  ];

  const isPublicRoute = publicRoutes.some(
    (path) =>
      location.pathname === path || location.pathname.startsWith(path + "/")
  );

  // If route is not admin and not public → 404
  const isNotFoundRoute = !isAdminRoute && !isPublicRoute;

  return (
      <div className="App" onContextMenu={handleContextMenu}>
      {isNotFoundRoute ? (
        <NotFound />
      ) : isAdminRoute ? (
          <AdminDashboard resetSlider={resetSlider} />
      ) : (
         <div>
          <ToastContainer />
          <Header onTabChange={handleResetSlider} /> {/* Pass reset handler */}
          <Content resetSlider={resetSlider} /> {/* Pass reset state */}
           <Footer />
         </div>
      )}
    </div>
  );
}

export default App;
